module.exports = __webpack_public_path__ + "static/media/Olivia Williamson.cc8a68e9.png";